import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const ModalContentBody = styled("div")({
  paddingBottom: 40,
});

const ModalContentTitle = styled("div")({
  paddingBottom: 24,
  "& > span": {
    color: "#344054",
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "20px",
    letterSpacing: 0.25,
  },
});

const styles = makeStyles(() => ({
  modal: {
    minWidth: "920px",
  },
}));

const ModalContent = {
  Body: ModalContentBody,
  Title: ModalContentTitle,
};

export { ModalContent };

export default styles;
